import flagsmith from '@flagsmith/flagsmith'
import {
  FlagsmithProvider,
  useFlagsmith,
  useFlagsmithLoading,
} from '@flagsmith/flagsmith/react'
import { type ReactNode, useEffect } from 'react'

import { flagsmithConfig } from '@/config/flagsmith'
import { useAuth } from '@/hooks/use-auth'

export {
  useFlags,
  useFlagsmith,
  useFlagsmithLoading,
} from '@flagsmith/flagsmith/react'

export function useFlagsmithReady(): boolean {
  const loadingState = useFlagsmithLoading()

  if (!flagsmithConfig.isEnabled) {
    return true
  }

  return !loadingState?.isLoading && !loadingState?.isFetching
}

interface FlagsmithAppProviderProps {
  children: ReactNode
}

function IdentificarUsuarioFlagsmith(): null {
  const { estaAutenticado, login, email } = useAuth()
  const flagsmithClient = useFlagsmith()

  useEffect(() => {
    if (!estaAutenticado || !login) {
      void flagsmithClient.logout().catch(() => {
        console.error('Erro ao desconectar usuário no Flagsmith')
      })
      return
    }

    void flagsmithClient
      .identify(login, email ? { email } : undefined)
      .catch(() => {
        console.error('Erro ao identificar usuário no Flagsmith')
      })
  }, [estaAutenticado, login, email, flagsmithClient])

  return null
}

export function FlagsmithAppProvider({
  children,
}: FlagsmithAppProviderProps): JSX.Element {
  if (!flagsmithConfig.isEnabled) {
    return <>{children}</>
  }

  return (
    <FlagsmithProvider
      flagsmith={flagsmith}
      options={flagsmithConfig.initOptions}
    >
      <IdentificarUsuarioFlagsmith />
      {children}
    </FlagsmithProvider>
  )
}
